module.exports = __webpack_public_path__ + "static/media/Copyright.0f0faa76.jpg";